import { Pipe, PipeTransform } from '@angular/core';
import { UserToNameCacheService } from '../services/userToNameCache.service';

@Pipe({
	name: 'userToName',
	pure: false,
	standalone: false,
})
export class UserToNamePipe implements PipeTransform {
	constructor(private userToNameCache: UserToNameCacheService) {}

	transform(value: string): string {
		if (this.userToNameCache.isInitializing() || this.userToNameCache.isLoading()) {
			return 'Loading...';
		}

		return this.userToNameCache.userCache().get(value) || 'Unknown User';
	}
}
